/**
 * SIDCDatawarehouseSales
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateReturnFromCustomerCommand { 
    id?: number;
    idLedger?: number;
    transactionDate?: Date;
    transactionTypeId?: number;
    transactionTypeCode?: string;
    reference?: string;
    salesTransactionId?: number;
    crossReference?: string;
    isNoEffectOnInventory?: boolean;
    customerTypeId?: number;
    businessPartnerId?: number;
    businessPartnerCode?: string;
    businessPartnerName?: string;
    glAccountId?: number;
    glAccountCode?: string;
    glAccountName?: string;
    paidToDate?: number;
    total?: number;
    isCancelled?: boolean;
    returnFromCustomerStatusId?: number;
    returnFromCustomerStatusDescription?: string;
    isExtracted?: boolean;
    colaReference?: string;
    mainSegmentId?: number;
    mainSegmentCode?: string;
    businessSegmentId?: number;
    businessSegmentCode?: string;
    branchId?: number;
    branchCode?: string;
    signatory?: string;
    remarks?: string;
    systemDate?: Date;
    seniorDiscount?: number;
    feedsDiscount?: number;
    vat?: number;
    vatExemptSales?: number;
    vatAmount?: number;
    warehouseId?: number;
    warehouseCode?: string;
    lrBatch?: string;
    lrType?: string;
    lrReference?: string;
    kanegoDiscount?: number;
    grossTotal?: number;
    sow?: string;
    parity?: string;
    idUser?: string;
    accounNumber?: string;
    terminalNumber?: string;
    minNumber?: string;
}